import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {LoginService} from 'lps-navigation';

import {delay, map, retryWhen, take} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';

import {WidgetInfoModel, WidgetModel} from 'src/app/core/models/widget.model';
import {EnvironmentService} from 'src/app/core/enviroment/environment.service';
import {DropActionModel} from '../../core/models/sidemenu.model';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  private uri = this.environmentService.getEnvVar('api_home');
  public uriv2 = this.environmentService.getEnvVar('api_facs_v2');
  private retryITNERVAL = 500;
  private retryLIMIT = 10;
  public homeData: any;
  public dashData: any;
  public sidebarData: any;
  public sideMenuDraggables: any;
  public profileData: any;

  public getDashDataFinished: boolean;
  public storedDateTime: any;

  public smWidgets: Subject<WidgetModel[]> = new Subject<WidgetModel[]>();
  public smWidgetsSet: WidgetModel[] = [];
  public mdWidgets: Subject<WidgetModel[]> = new Subject<WidgetModel[]>();
  public widgetInfo: Subject<WidgetInfoModel> = new Subject<WidgetInfoModel>();

  public fixedMdWidgets = [
    {
      id: '76aca7de-1cf3-4dd5-85c9-edf40cf549d7',
      title: 'Funil de atendimento',
      type: 'funnel',
      values: [],
      update_timer: 60000,
      action: {
        type: '',
        target: '',
        url: ''
      },
      size: 'medium'
    },
    {
      id: '7afed576-02c5-4fce-967b-6773e3e4c960',
      title: 'Tarefas do dia',
      type: 'activities',
      values: [],
      update_timer: 60000,
      action: {
        type: '',
        target: '',
        url: ''
      },
      size: 'medium'
    }
  ];

  constructor(
    public http: HttpClient,
    private loginService: LoginService,
    private environmentService: EnvironmentService
  ) { }

  get jwtToken(): string {
    return this.loginService.getAuthInformation().token;
  }

  public clearHomeCrmToken() {
    this.sidebarData = null;
    this.profileData = null;
    this.getDashDataFinished = false;
  }

  public getCrmHome() {
    return this.http.get<any>(`${this.uri}/crm-home`);
  }

  public getDashWidgets() {
    return this.http.get<any>(`${this.uri}/cards?` + Math.random());
  }

  public getDashWidgetData(id: string) {
    return this.http.get<any>(`${this.uri}/card-info/${id}?` + Math.random());
  }

  public putDashWidgets(widgets: WidgetModel[]) {
    return this.http.put<any>(`${this.uri}/cards`,
      {
        layout: 1,
        card_items: widgets
      });
  }

  public getSmWidgets() {
    return this.smWidgets.asObservable();
  }

  public setSmWidgets(widgets: WidgetModel[]) {
    this.smWidgets.next(widgets);
  }

  public getMdWidgets() {
    return this.mdWidgets.asObservable();
  }

  public setMdWidgets(widgets: WidgetModel[]) {
    this.mdWidgets.next(widgets);
  }

  public getwidgetInfo() {
    return this.widgetInfo.asObservable();
  }

  public setwidgetInfo(info: WidgetInfoModel) {
    this.widgetInfo.next(info);
  }

  public changeQueueStatus(status) {
    return this.http.put<any>(`${this.uri}/queue-status`, status);
  }

  public setQueueAway() {
    return this.http.patch<any>(`${this.uri}/queue/status-away`, {});
  }

  public getDashData() {
    if (!this.jwtToken) { return false; }
    this.dashData = this.getDashWidgets()
      .subscribe(
        (res) => {
          this.setSmWidgets(res.card_items);
          this.setMdWidgets(this.fixedMdWidgets);
          this.smWidgetsSet = res.card_items;
          this.getDashDataFinished = true;
        },
        (err) => console.log(err)
      );
  }

  public fetchWidgetData(widgetId: string) {
    if (!this.jwtToken) { return false; }
    this.getDashWidgetData(widgetId)
      .subscribe(
        (res) => {
          if (res && res.informations) {
            const wInfo: WidgetInfoModel = {
              id: widgetId,
              info: res.informations
            };
            this.setwidgetInfo(wInfo);
          }
        },
        (err) => console.log(err)
      );
  }

  public updateDashData(widgets: WidgetModel[]) {
    if (!this.jwtToken) { return false; }
    this.putDashWidgets(widgets).subscribe(
      resp => {
        if (resp.status.id === 0) {
          this.checkTaskStatus(resp.taskId).subscribe(response => {
            if (!response) {
              return false;
            }
            this.getDashData();
          },
            err => {
              console.log(err);
            });
        }
      }
    );
  }

  public updateServerDateTime(dateTime: any): void {
    this.storedDateTime = dateTime;
  }

  public checkTaskStatus(taskId): Observable<any> {
    let count = 1;
    return this.http.get<any>(`${this.uri}/task/${taskId}`).pipe(
      map(response => {
        if (count >= this.retryLIMIT) {
          return null;
        }
        if (response.status.id === 0) {
          count = count + 1;
          throw response;
        }
        return response;
      }),
      retryWhen((errors: any) => {
        return errors.pipe(delay(this.retryITNERVAL), take(this.retryLIMIT));
      })
    );
  }

  public getDraggableSidemenuItems(sidebar) {
    const sidemenuDraggables = [];
    for (const item of sidebar) {
      if (item.menu_item.draggable) {
        sidemenuDraggables.push(item.menu_item);
      }
      if (item.sub_menu_items) {
        for (const sub of item.sub_menu_items) {
          if (sub.draggable) {
            sidemenuDraggables.push(sub);
          }
        }
      }
    }
    // widgets outside sidemenu
    sidemenuDraggables.push({
      id: '5be581e8-3cab-43cc-8b19-b7c913615298',
      action: {
        type: '',
        target: '',
        url: ''
      },
      draggable: true,
      label: 'Facs favoritas',
      icon: '',
      card_title: 'Facs favoritas'
    });
    sidemenuDraggables.push({
      id: '842dd4f7-8e15-47ea-80c4-6a1c4341c1fc',
      action: {
        type: '',
        target: '',
        url: ''
      },
      draggable: true,
      label: 'Visitas agendadas',
      icon: '',
      card_title: 'Visitas agendadas'
    });
    sidemenuDraggables.push({
      id: 'ff20ec35-854d-4675-a058-fdfd8d357f55',
      action: {
        type: '',
        target: '',
        url: ''
      },
      draggable: true,
      label: 'Relógio',
      icon: '',
      card_title: 'Relógio'
    });
    this.sideMenuDraggables = sidemenuDraggables;
  }

  addDashWidget(action: DropActionModel) {
    this.smWidgetsSet[action.position] = {
      id: action.item.id,
      type: action.item.label,
      title: action.item.card_title,
      update_timer: action.item.card_update_timer,
      action: action.item.action
    };
    this.updateDashData(this.smWidgetsSet);
  }

  public filterFacInAttendance(ranges: any): any {
    return {
      and: {
        ranges: [ranges],
        filters: [
          {
            field: 'funnel_stage.value',
            value: 'Em Atendimento',
            match: 'PHRASE'
          }
        ],
        tags: []
      }
    };
  }

  public filterFacPerformanceTeam(ranges: any): any {
    return {
      and: {
        ranges: [ranges],
        filters: [],
        tags: []
      }
    };
  }

  getCountContactType(ranges: any) {
    const param = this.filterFacInAttendance(ranges);
    return this.http.post<any>(`${this.uriv2}/fac/count-contact-type`, param);
  }

  getCountPerformanceTeam(ranges: any) {
    const param = this.filterFacPerformanceTeam(ranges);
    return this.http.post<any>(`${this.uriv2}/fac/performance-team`, param);
  }

}
